module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-icon",
    on: {
      "click": _vm.click
    }
  }, [_c('svg', {
    attrs: {
      "width": _vm.size,
      "height": _vm.size,
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512",
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": '#' + _vm.name,
      "fill": _vm.color
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd0e2e44"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/icon/index.vue
// module id = 2161
// module chunks = 228